<ng-container [ngSwitch]="type">

  <!-- default for PASSWORD TEXT STRING NUMBER DOUBLE EMAIL BOOL TEXTAREA -->
  <ng-container *ngSwitchDefault>
    <fn-base-input [(ngModel)]="value" [id]="config.id" [name]="name" [disabled]="isDisabled" [isErrorBox]="'false'"
                   [type]="type">
    </fn-base-input>

    <!-- @Input() name: string;
      @Input() id: string;
      @Input() placeholder: string;
      @Input() isDisabled: boolean;
      @Input() textAlign: 'left' | 'right' | 'center' | 'justify' = 'left';
      @Input() isErrorBox = true;
      @Input() minLength = 0;
      @Input() isRequired = false;
      @Input() maxLength = 255;
      @Input() type: string;
      @Input() parentForm: any;
      @Input() readonly: boolean = null;
      @Input() autocomplete = 'off';
      @Input() tabindex = 0;
      @Input() pattern?: any;


      isRequired: true,
      isEnableOnUI: true,
      labelIDArray: [
      'Entity_EOEmpMain_Field_email_LBL',
      'Entity_EOEmpMain_Field_email_HVR'
      ],
      minLength: 5,
      isInitialized: true,
      isShowInfo: false,
      labelPosition: 'left',
      recalAccess: false,
      typeID: {
      iid: 'EMAIL',
      isNumber: false,
      defaultTableWidth: 50,
      defaultEditWidth: 20
      },
      applicablePK: 0,
      id: 'Entity_EOEmpMain_Field_email',
      isDisabled: false,
      key: 'email',
      maxLength: 255,
      isDynDetailKey: false,
      hideLabel: false -->


  </ng-container>

  <ng-container *ngSwitchCase="inputTypeMap.PHONENUMBER">
    <!-- TODO for phone number -->
  </ng-container>
  <ng-container *ngSwitchCase="inputTypeMap.CURRENCY">
    <!-- Currency -->
  </ng-container>

  <ng-container *ngSwitchCase="inputTypeMap.LOOKUP">
    <!-- Single Lookp -->
  </ng-container>
  <ng-container *ngSwitchCase="inputTypeMap.MULTILOOKUP">
    <!-- Multi Lookup Lookp -->
  </ng-container>

  <ng-container *ngSwitchCase="inputTypeMap.COLOR">
    <!-- Color -->
  </ng-container>

  <ng-container *ngSwitchCase="inputTypeMap.TEMPERATURE">
    <!-- Multi Lookup Lookp -->
  </ng-container>

  <ng-container *ngIf="parentForm">
    <fn-input-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]">
    </fn-input-error>
  </ng-container>

</ng-container>


<!-- <fn-base-input-component-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]">
</fn-base-input-component-error> -->

<!-- <ng-container *ngSwitchCase="inputTypeMap.DATE">

    </ng-container> -->

<!-- <ng-container *ngSwitchCase="inputTypeMap.DURATION">

    </ng-container>
    <ng-container *ngSwitchCase="inputTypeMap.TIME">

    </ng-container> -->
